import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useNavigationHistory } from './navigationHistory';

const NavigationTracker = () => {
  const location = useLocation();
  const { push } = useNavigationHistory();

  useEffect(() => {
    push(location.pathname);
  }, [location.key]); // ←これ重要

  return null;
};

export default NavigationTracker;